/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-solo-visibility',
  template: `
    <p class="alert alert-warning" *ngIf="(!model || !(model.id || model.length > 0)) && !isNew">
      <span>{{ ('solo.' + transKey) | ogTranslate }}</span>
    </p>
  `
})
export class SoloVisibilityInfoComponent {
  @Input() model: any;
  @Input() isNew: boolean;
  @Input() transKey= 'default';
}
